import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreDirectivesModule } from '@core/directives/directives';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FlatpickrModule } from 'angularx-flatpickr';
import { SelectFieldComponent } from 'app/main/pages/contract-control/editable-fields/select-field/select-field.component';
import { TextFieldComponent } from 'app/main/pages/contract-control/editable-fields/text-field/text-field.component';
import { IDocumentDetailRootDTO } from 'app/main/pages/documents/dto/document-details.dto';
import { ExtractSenderDetailPipe } from 'app/pipes/documents-right-sidebar-pipes/extract-sender-details.pipe';
import { MomentPipe } from 'app/pipes/moment.pipe';
import { UserTimeZoneFormatPipe } from 'app/pipes/user-timezone-format.pipe';
import { TranslocoRootModule } from 'app/transloco-root.module';
import { FieldActionEvent } from '../dynamic-field.component';
import { IField } from 'app/main/pages/settings/documenttype/document-type-settings-modal/document-type-settings.dto';

@Component({
  selector: 'app-signing-reminder',
  standalone: true,
  imports: [
    CommonModule,
    CoreDirectivesModule,
    TranslocoRootModule,
    NgSelectModule,
    TextFieldComponent,
    SelectFieldComponent,
    NgbTooltipModule,
    ExtractSenderDetailPipe,
    FlatpickrModule,
    MomentPipe,
    UserTimeZoneFormatPipe,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './signing-reminder.component.html',
  styleUrl: './signing-reminder.component.scss'
})
export class SigningReminderComponent {

  @Input() formGroup!: FormGroup;
  @Input() documentData: IDocumentDetailRootDTO;
  @Input() canEdit: boolean = true;
  @Output() actionEmit = new EventEmitter<FieldActionEvent>();
  @Input()
  set field(value: IField) {
    this._field = structuredClone(value);
  }

  get field(): IField {
    return this._field;
  }


  public _field: IField;


  onSigningReminderChange(value: string): void {
    this.actionEmit.emit({ action: 'onSigningReminderChange', data: value });
  }


  onRecurringChange(value: boolean): void {
    this.actionEmit.emit({ action: 'onRecurringChange', data: value });
  }
}
